import { frontendURL } from '../../../../helper/URLHelper';
import AiBotIndex from './Index.vue';
import SettingsWrapper from '../SettingsWrapper.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/ai-bot'),
      meta: {
        permissions: ['administrator'],
      },
      component: SettingsWrapper,
      children: [
        {
          path: '',
          name: 'ai_bot_settings',
          component: AiBotIndex,
          meta: {
            permissions: ['administrator'],
            platformService: 'ai_bot',
            reuseOnQueryChange: true,
          },
        },
      ],
    },
  ],
};
